import React, { Component } from 'react';
import {NavLink, Link} from 'react-router-dom';


class Header extends Component {
    constructor(props) {
        super(props);



         this.state={
           access_token:this.props.admin_token,
           user_details:this.props.admin_details,
           loading:true,
           loaded_successfully:false,
           api_error_message:"",
           server_changes_made:"",

         }
      }


  render() {

      const _this = this;

    return (


        <nav className="navbar navbar-expand-lg navbar-transparent navbar-absolute fixed-top ">
            <div className="container-fluid">
                <div className="navbar-wrapper">
                    <NavLink className="navbar-brand" to="#">{_this.props.title}</NavLink>
                </div>
                <button className="navbar-toggler" type="button" data-toggle="collapse" aria-controls="navigation-index" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="sr-only">Toggle navigation</span>
                    <span className="navbar-toggler-icon icon-bar"></span>
                    <span className="navbar-toggler-icon icon-bar"></span>
                    <span className="navbar-toggler-icon icon-bar"></span>
                </button>
                <div className="collapse navbar-collapse justify-content-end">
                    <ul className="navbar-nav">
                        <li className="nav-item dropdown">
                            <NavLink className="nav-link" to="#pablo" id="navbarDropdownProfile" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i className="material-icons">person</i>
                            <p className="d-lg-none d-md-block">
                                Account
                            </p>
                            </NavLink>
                            <div className="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownProfile">
                            <NavLink className="dropdown-item" to="#">Profile</NavLink>
                            <NavLink className="dropdown-item" to="#">Settings</NavLink>
                            <div class="dropdown-divider"></div>
                                <NavLink class="dropdown-item" to="#">Log out</NavLink>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>



    );
  }
}

export default Header;
